import { consultaB } from '../../consultaB';
import { getOne } from '../pwa-utils/db-informacion';
/////////// PRODUCCIÓN
var URL_BASE = location.hostname
var PROTOCOLO = location.protocol + '//'

/////////// LOCAL
// import secret from '../../../secret.json';
// let local = ''; 

var BACK = ''

if ((URL_BASE.includes("localhost")||URL_BASE.includes("127.0.0.1")) && BACK == '') {
  try {    
    if (local == '' || local == undefined) {
      alert('Cambie el nombre del proyecto que desea consultar')
    }
    secret.forEach(miB=>{
      if (miB.proyecto==local) {
        PROTOCOLO = miB.protocolo
        URL_BASE = miB.base
        BACK = miB.back
      }
    })
    
  } catch (error) {
    alert('Por favor revise el documento de urls.js')
  }

}else{
    let id_back = consultaB()
    // console.log(id_back);
    getOne('b').then(miB=>{   
      // console.log('desde url', miB.atributo);   
      id_back = miB.atributo
    })
    
    switch (id_back) {
      case '4UZrqZKsDo':
        BACK = PROTOCOLO + URL_BASE + ':8000'
        break;
      case '2cJB4bnXVn':
        BACK = PROTOCOLO + URL_BASE + ':8080'
        break;
      case 'IcTYghPVQC':
        BACK = PROTOCOLO + 'backend.' + URL_BASE
        break;
      case '6cA6mKSVyW':
        BACK = PROTOCOLO + 'backend' + URL_BASE
        break;
      default:
        break;
    }
}

//URLS BACKEND
export const BACK_URL = BACK
export const PYTHON_URL = BACK_URL+'/api/'
//URLS PLATAFORMA
export const SERVER_URL = PROTOCOLO+URL_BASE
export const FORM_URL = SERVER_URL+'/ideep_formulario/index.html?'
export const MODULO_URL = SERVER_URL+'/ideep_modulo360/index.html?'

//si está definido el localstorage, se envían las url's para el formulario
if (typeof localStorage != 'undefined') {
  localStorage.setItem('BACK_URL',BACK_URL)
  localStorage.setItem('SERVER_URL',SERVER_URL)
}